export default {
  'Teklif Formu': 'Angebotsformular',
  'Kayıtlı Teklifler': 'Gespeicherte Angebote',
  'Kullanıcı Adı': 'Benutzername',
  'Şifre': 'Passwort',
  'Giriş Yap': 'Anmelden',
  'Çıkış Yap': 'Abmelden',
  'KDV Oranı': 'MwSt-Satz',
  'Teklif Durumu': 'Angebotsstatus',
  'Kaydet': 'Speichern',
  'PDF Önizleme': 'PDF-Vorschau',
  'PDF\'ye Aktar': 'Als PDF exportieren',
  'E-posta ile Gönder': 'Per E-Mail senden',
  'Alıcı': 'Empfänger',
  'Tarih': 'Datum',
  'Genel Toplam': 'Gesamtsumme',
  'Not': 'Notiz',
  'KDV': 'MwSt',
  'Alt Toplam': 'Zwischensumme',
  'Açıklama': 'Beschreibung',
  'Ürün Adı': 'Produktname',
  'SUT Kodu': 'SUT-Code',
  'Birim Alış Fiyatı': 'Einzelpreis',
  'Sipariş Adedi': 'Bestellmenge',
  'Promosyon Ürün': 'Promo-Produkt',
  'Toplam Adet': 'Gesamtmenge',
  'Sipariş Tutarı': 'Bestellsumme',
  'Durum': 'Status',
  'Kabul Edildi': 'Akzeptiert',
  'Reddedildi': 'Abgelehnt',
  'Gönderildi': 'Gesendet',
  'Taslak': 'Entwurf',
  'Yurtiçi': 'Inland',
  'Yurtdışı': 'Ausland',
  'Sipariş Oluştur': 'Bestellung Erstellen',
  'Ürün Sıralaması': 'Produktsortierung',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Produkte sind nach Popularität und Wichtigkeit sortiert',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Kardiologie- und Gefäßchirurgie-Produkte werden vorrangig angezeigt',
  'Ürün adı, açıklama veya barkod ile ara...': 'Nach Produktname, Beschreibung oder Barcode suchen...',
  'Tüm Kategoriler': 'Alle Kategorien',
  'Kutu görünüm': 'Rasteransicht',
  'Liste görünüm': 'Listenansicht',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Keine Produkte gefunden, die Ihren Suchkriterien entsprechen',
  'Ürün Adı Yok': 'Kein Produktname',
  'Kategori Yok': 'Keine Kategorie',
  'Açıklama yok': 'Keine Beschreibung',
  'Firma Bilgilerini Doldurun': 'Firmeninformationen Ausfüllen',
  'Sepete Ekle': 'Zum Warenkorb Hinzufügen',
  'Firma Bilgileri': 'Firmeninformationen',
  'Ülke Seçimi': 'Länderauswahl',
  'Türkiye': 'Türkei',
  'Almanya': 'Deutschland',
  'ABD': 'USA',
  'Firma Ünvanı': 'Firmenname',
  'Vergi Dairesi': 'Finanzamt',
  'Vergi Numarası': 'Steuernummer',
  'Adres': 'Adresse',
  'Şehir': 'Stadt',
  'Şehir Seçimi': 'Stadtauswahl',
  'Şehir Seçiniz': 'Stadt auswählen',
  'Şehir adı ara...': 'Stadtname suchen...',
  'Aradığınız şehir bulunamadı': 'Stadt nicht gefunden',
  'Bu ülke için şehir verisi bulunamadı': 'Keine Stadtdaten für dieses Land verfügbar',
  'şehir bulundu': '{{count}} Städte gefunden',
  'Yetkili': 'Bevollmächtigte Person',
  'Telefon': 'Telefon',
  'Email': 'E-Mail',
  'Bilgileri İlet': 'Informationen Senden',
  'Lütfen eksik alanları doldurun': 'Bitte füllen Sie die fehlenden Felder aus',
  'Firma kaydedilemedi': 'Firma konnte nicht gespeichert werden',
  'Firma bilgileri başarıyla iletildi': 'Firmeninformationen erfolgreich gesendet',
  'Firma Ünvanı:': 'Firmenname:',
  'Yetkili Kişi:': 'Bevollmächtigte Person:',
  'Sepetiniz': 'Ihr Warenkorb',
  'Sepetiniz boş': 'Ihr Warenkorb ist leer',
  'adet': 'Stk',
  'Düzenle': 'Bearbeiten',
  'Kaldır': 'Entfernen',
  'Siparişi Tamamla': 'Bestellung Abschließen',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Bitte senden Sie zuerst die vollständigen Firmeninformationen',
  'Sipariş başarıyla kaydedildi': 'Bestellung erfolgreich gespeichert',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Willkommensnachricht und Zugangslink an Ihre E-Mail-Adresse gesendet',
  'Link 3 gün geçerlidir': 'Link ist 3 Tage gültig',
  'Sipariş kaydedilemedi': 'Bestellung konnte nicht gespeichert werden',
  'Firma Bilgileri Gerekli': 'Firmeninformationen Erforderlich',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Füllen Sie zuerst die Firmeninformationen aus, um zum Warenkorb hinzuzufügen',
  'Önce Bilgileri Doldurun': 'Füllen Sie zuerst die Informationen aus',
  'Uyarı': 'Warnung',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Sie müssen zuerst die Firmeninformationen ausfüllen, um zum Warenkorb hinzuzufügen',
  'SUT Kütüphanesi Tanımı': 'SUT-Bibliothek Definition',
  'SUT Kodu:': 'SUT-Code:',
  'Standart': 'Standard',
  'Açıklama (isteğe bağlı)': 'Beschreibung (optional)',
  'Partner Ol': 'Partner Werden',
  'Partner başvuru popup açılacak': 'Partner-Anfrage-Popup wird geöffnet',
  'Dil': 'Sprache',
  'E-posta': 'E-Mail-Adresse',
  'E-Posta': 'E-Mail-Adresse',
  'Şifre': 'Passwort',
  'Şifremi Unuttum': 'Passwort Vergessen',
  'Giriş yapılıyor...': 'Anmeldung läuft...',
  'E-posta veya şifre hatalı': 'E-Mail-Adresse oder Passwort falsch',
  'Şifre sıfırlama e-postası gönderildi': 'Passwort-Reset-E-Mail gesendet',
  'E-posta gönderilemedi': 'E-Mail konnte nicht gesendet werden',
  'Üye Ol': 'Registrieren',
  'Üye Değil Misiniz?': 'Sind Sie kein Mitglied?',
  'Şimdi Üye Ol': 'Jetzt Registrieren',
  'Misafir Kullanıcı': 'Gastbenutzer',
  'Hızlı Sipariş': 'Schnelle Bestellung',
  'Misafir Olarak Sipariş Verin': 'Als Gast bestellen',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Wählen Sie schnell Ihre Produkte aus und erstellen Sie Ihre Bestellung ohne Anmeldung',
  'Giriş yapmadan sipariş oluşturun': 'Bestellung ohne Anmeldung erstellen',
  'Anında Erişim': 'Sofortiger Zugang',
  'Tüm ürünlere anında erişim': 'Sofortiger Zugang zu allen Produkten',
  'Güvenli İşlem': 'Sichere Transaktion',
  'SSL korumalı güvenli sipariş': 'SSL-geschützte sichere Bestellung',
  'Misafir Olarak Sipariş Oluştur': 'Bestellung als Gast erstellen',
  'İpucu:': 'Tipp:',
  'Daha fazla özellik için üye olun': 'Registrieren Sie sich für mehr Funktionen',
  'Ücretsiz': 'Kostenlos',
  'Hızlı': 'Schnell',
  'Güvenli': 'Sicher',
  'bayilikSozlesme': 'Ich habe die Partnerschaftsbedingungen und -vertrag von INVAMED gelesen und akzeptiert.',
  'geri': 'Zurück',
  'basvuruGonder': 'Antrag Einreichen',
  'ileri': 'Weiter',
  'sozlesmeGonderildi': 'Vertrag an Ihre E-Mail-Adresse Gesendet!',
  'sozlesmeDesc': 'Bitte laden Sie den INVAMED-Partnerschaftsvertrag und die erforderlichen Dokumente, die an Ihre E-Mail-Adresse gesendet wurden, unten hoch.',
  'tamamla': 'Antrag Abschließen',
  'basvuruAlindi': 'Ihr Antrag Wurde Empfangen!',
  'basvuruAlindiDesc': 'Das INVAMED-Team wird Ihren Antrag prüfen und sich so schnell wie möglich mit Ihnen in Verbindung setzen.',
  'Başvuru Durumu': 'Bewerbungsstatus',
  'Başvurunuz onay sürecindedir': 'Ihre Bewerbung wird geprüft',
  'sifreSifirla': 'Passwort Zurücksetzen',
  'sifreSifirlaDesc': 'Geben Sie Ihre registrierte E-Mail-Adresse ein und wir senden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts.',
  'gonder': 'Senden',
  'talimatGonderildi': 'Anweisungen Gesendet',
  'sentDesc': 'Anweisungen zum Zurücksetzen des Passworts wurden an <b>{email}</b> gesendet. Bitte überprüfen Sie Ihre E-Mail.',
  'helpTitle': 'Wie kann ich mich anmelden?',
  'helpList': [
    'Um sich beim INVAMED-Händlerpanel anzumelden, geben Sie Ihre registrierte E-Mail-Adresse und Ihr Passwort ein.',
    'Um sich mit dem Demo-Benutzer anzumelden:',
    'Wenn Sie Ihr Passwort vergessen haben, verwenden Sie den Link "Passwort vergessen", um eine Zurücksetzung zu beantragen.',
    'Bei Anmeldeproblemen stellen Sie sicher, dass Ihre E-Mail und Ihr Passwort korrekt sind. Wenn das Problem weiterhin besteht, kontaktieren Sie unser Support-Team.'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED Partnerschaftsvertrag und Bedingungen',
  'partnerlikSozlesmeText': `1. ALLGEMEINE BESTIMMUNGEN

Diese Vereinbarung wird zwischen INVAMED (im Folgenden als "Unternehmen" bezeichnet) und dem Partnerkandidaten (im Folgenden als "Partner" bezeichnet) zum Zweck der Zusammenarbeit beim Verkauf von medizinischen Geräten und Ausrüstungen geschlossen.

2. PARTNERSCHAFTSBEDINGUNGEN

2.1. Der Partner muss die rechtliche Befugnis für den Verkauf medizinischer Geräte haben.
2.2. Der Partner muss eine Organisation sein, die im Gesundheitssektor tätig ist.
2.3. Der Partner muss die erforderlichen Lizenzen und Zertifikate haben.
2.4. Der Partner muss finanziell zuverlässig sein.

3. VERPFLICHTUNGEN DER PARTEIEN

Verpflichtungen des Unternehmens:
3.1. Qualitätsprodukte und -dienstleistungen bereitstellen
3.2. Technischen Support bereitstellen
3.3. Schulung und Informationen bereitstellen
3.4. Transparent bei der Preisgestaltung sein

Verpflichtungen des Partners:
3.1. Produkte unter angemessenen Bedingungen lagern
3.2. Qualitätskundendienst bereitstellen
3.3. Rechtliche Vorschriften einhalten
3.4. Die Unternehmensmarke schützen

4. PREISGESTALTUNG UND ZAHLUNG

4.1. Preise werden vom Unternehmen festgelegt
4.2. Der Partner ist verpflichtet, die festgelegten Preise einzuhalten
4.3. Zahlungsbedingungen werden gesondert festgelegt
4.4. Provisionssätze können je nach Leistung variieren

5. VERTRAULICHKEIT UND SICHERHEIT

5.1. Die Parteien sind verpflichtet, die vertraulichen Informationen des jeweils anderen zu schützen
5.2. Kundeninformationen müssen vertraulich behandelt werden
5.3. Datensicherheitsstandards müssen eingehalten werden

6. DAUER UND KÜNDIGUNG DER VEREINBARUNG

6.1. Diese Vereinbarung ist 1 Jahr gültig
6.2. Kann durch gegenseitige Vereinbarung verlängert werden
6.3. Kann mit 30 Tagen Kündigungsfrist gekündigt werden
6.4. Kann bei schwerwiegenden Verstößen sofort gekündigt werden

7. STREITBEILEGUNG

7.1. Streitigkeiten werden hauptsächlich durch Verhandlung zu lösen versucht
7.2. Gerichte der Republik Türkei sind für ungelöste Fälle zuständig

8. WIRKSAMKEIT

Diese Vereinbarung wurde von den Parteien gelesen, verstanden und akzeptiert.`,
  'partnerlikSozlesmeOnay': 'Ich habe den obigen INVAMED-Partnerschaftsvertrag und die Bedingungen gelesen, verstanden und akzeptiert. Ich erkläre, dass ich alle Artikel dieser Vereinbarung akzeptiere und meine Verpflichtungen erfüllen werde.',
  'sozlesmeyiGoruntule': 'Vertrag Anzeigen',
  'sozlesmeyiKapat': 'Schließen',
  'Ürün': 'Produkt',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Wählen Sie Produkte aus der Liste aus, um sie zum Warenkorb hinzuzufügen',
  'Etiketler': 'Etiketten',
  'Öncelikli': 'Priorität',
  'Kapat': 'Schließen',
  'globalPartnersTitle': 'Zusammenarbeit mit 30.000 Partnern weltweit',
  'globalPartnersDesc': 'Unser umfangreiches globales Netzwerk von 30.000 Partnern treibt gemeinsame Innovation, Wissensaustausch und gegenseitigen Erfolg voran. Durch gemeinsames Arbeiten erweitern wir kontinuierlich die Grenzen der Patientenversorgung.',
  'Yardım': 'Hilfe',
  'dil': 'Sprache',
  'Connect Free!': 'Kostenlos verbinden!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Entdecken Sie unsere beliebtesten Produkte',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 Produkte angezeigt (Insgesamt: 8000+)',
  'Tüm Ürünleri Gör →': 'Alle Produkte anzeigen →',
  'Detaylar': 'Details',
  'Sipariş Ver': 'Bestellen',
  'Giriş Yap': 'Anmelden',
  'Hesabınıza giriş yapın': 'Melden Sie sich bei Ihrem Konto an',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Diese Seite ist durch reCAPTCHA geschützt und es gelten die Google-Datenschutzrichtlinie und Nutzungsbedingungen.',
  'Ürün Kataloğumuz': 'Unser Produktkatalog',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Wir bieten über 8000 Produktvarianten an',
  '1,3B': '1,3Tsd.',
  'Partner': 'Partner',
  '8,4M': '8,4Mio.',
  'Toplam Üretim': 'Gesamtproduktion',
  '23': '23',
  'Branş': 'Fachbereich',
  '27,5B': '27,5Tsd.',
  'Toplam Sipariş': 'Gesamtbestellungen',
  'Connect Now': 'Jetzt verbinden',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Registrieren Sie sich kostenlos, um auf alle Informationen an einem Ort zuzugreifen.',
  'Ürün Detayları': 'Produktdetails',
  'Kapat': 'Schließen',
  'Yükleniyor...': 'Lädt...',
  'Hata': 'Fehler',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} Produkte angezeigt (Insgesamt: 8000+)',
  'Şehir Seçimi': 'Stadtauswahl',
  'Firma / Sağlık Profesyoneli': 'Unternehmen / Gesundheitsfachkraft',
  'Yetkili Kişi': 'Bevollmächtigte Person',
  'Telefon': 'Telefon',
  'E-posta': 'E-Mail',
  'Temel Bilgiler': 'Grundinformationen',
  'Ek Bilgiler': 'Zusätzliche Informationen',
  'Faaliyet Alanı / Sektör': 'Tätigkeitsbereich / Sektor',
  'Ülke Seçimi': 'Länderauswahl',
  'Ülke adı veya kodu ara...': 'Ländernamen oder Code suchen...',
  'region.Avrupa': 'Europa',
  'region.Amerika': 'Amerika',
  'region.Asya': 'Asien',
  'region.Afrika': 'Afrika',
  'region.Okyanusya': 'Ozeanien',
  'region.Diğer': 'Andere',
  // Ülke çevirileri
  'country.TR': 'Türkei',
  'country.AL': 'Albanien',
  'country.DE': 'Deutschland',
  'country.AD': 'Andorra',
  'country.AT': 'Österreich',
  'country.BY': 'Weißrussland',
  'country.BE': 'Belgien',
  'country.BA': 'Bosnien und Herzegowina',
  'country.BG': 'Bulgarien',
  'country.CZ': 'Tschechien',
  'country.DK': 'Dänemark',
  'country.EE': 'Estland',
  'country.FO': 'Färöer',
  'country.FI': 'Finnland',
  'country.FR': 'Frankreich',
  'country.GI': 'Gibraltar',
  'country.GR': 'Griechenland',
  'country.GG': 'Guernsey',
  'country.HR': 'Kroatien',
  'country.NL': 'Niederlande',
  'country.IE': 'Irland',
  'country.ES': 'Spanien',
  'country.SE': 'Schweden',
  'country.CH': 'Schweiz',
  'country.IT': 'Italien',
  'country.IS': 'Island',
  'country.JE': 'Jersey',
  'country.ME': 'Montenegro',
  'country.LV': 'Lettland',
  'country.LI': 'Liechtenstein',
  'country.LT': 'Litauen',
  'country.LU': 'Luxemburg',
  'country.HU': 'Ungarn',
  'country.MT': 'Malta',
  'country.IM': 'Isle of Man',
  'country.MD': 'Moldawien',
  'country.MC': 'Monaco',
  'country.MK': 'Nordmazedonien',
  'country.NO': 'Norwegen',
  'country.PL': 'Polen',
  'country.PT': 'Portugal',
  'country.RO': 'Rumänien',
  'country.RU': 'Russland',
  'country.SM': 'San Marino',
  'country.RS': 'Serbien',
  'country.SK': 'Slowakei',
  'country.SI': 'Slowenien',
  'country.SJ': 'Svalbard und Jan Mayen',
  'country.UA': 'Ukraine',
  'country.GB': 'Vereinigtes Königreich',
  'country.VA': 'Vatikan',
  'country.AX': 'Ålandinseln',
  'country.US': 'Vereinigte Staaten',
  'country.AS': 'Amerikanisch-Samoa',
  'country.AI': 'Anguilla',
  'country.AG': 'Antigua und Barbuda',
  'country.AR': 'Argentinien',
  'country.AW': 'Aruba',
  'country.BS': 'Bahamas',
  'country.BB': 'Barbados',
  'country.BZ': 'Belize',
  'country.BM': 'Bermuda',
  'country.BO': 'Bolivien',
  'country.BR': 'Brasilien',
  'country.VG': 'Britische Jungferninseln',
  'country.CA': 'Kanada',
  'country.KY': 'Kaimaninseln',
  'country.CL': 'Chile',
  'country.CO': 'Kolumbien',
  'country.CR': 'Costa Rica',
  'country.CU': 'Kuba',
  'country.CW': 'Curaçao',
  'country.DM': 'Dominica',
  'country.DO': 'Dominikanische Republik',
  'country.EC': 'Ecuador',
  'country.SV': 'El Salvador',
  'country.FK': 'Falklandinseln',
  'country.GF': 'Französisch-Guayana',
  'country.GD': 'Grenada',
  'country.GL': 'Grönland',
  'country.GP': 'Guadeloupe',
  'country.GT': 'Guatemala',
  'country.GY': 'Guyana',
  'country.HT': 'Haiti',
  'country.HN': 'Honduras',
  'country.JM': 'Jamaika',
  'country.MQ': 'Martinique',
  'country.MX': 'Mexiko',
  'country.MS': 'Montserrat',
  'country.NI': 'Nicaragua',
  'country.PA': 'Panama',
  'country.PY': 'Paraguay',
  'country.PE': 'Peru',
  'country.PR': 'Puerto Rico',
  'country.BL': 'Saint-Barthélemy',
  'country.KN': 'Saint Kitts und Nevis',
  'country.LC': 'Saint Lucia',
  'country.MF': 'Saint-Martin',
  'country.PM': 'Saint-Pierre und Miquelon',
  'country.VC': 'Saint Vincent und die Grenadinen',
  'country.SX': 'Sint Maarten',
  'country.SR': 'Suriname',
  'country.TT': 'Trinidad und Tobago',
  'country.TC': 'Turks- und Caicosinseln',
  'country.UY': 'Uruguay',
  'country.VE': 'Venezuela',
  'country.VI': 'Amerikanische Jungferninseln',
  'country.AF': 'Afghanistan',
  'country.AZ': 'Aserbaidschan',
  'country.BH': 'Bahrain',
  'country.BD': 'Bangladesch',
  'country.AE': 'Vereinigte Arabische Emirate',
  'country.BN': 'Brunei',
  'country.BT': 'Bhutan',
  'country.CN': 'China',
  'country.TL': 'Osttimor',
  'country.ID': 'Indonesien',
  'country.AM': 'Armenien',
  'country.PH': 'Philippinen',
  'country.PS': 'Palästina',
  'country.GE': 'Georgien',
  'country.KR': 'Südkorea',
  'country.IN': 'Indien',
  'country.HK': 'Hongkong',
  'country.IQ': 'Irak',
  'country.IR': 'Iran',
  'country.IL': 'Israel',
  'country.JP': 'Japan',
  'country.KH': 'Kambodscha',
  'country.QA': 'Katar',
  'country.KZ': 'Kasachstan',
  'country.KG': 'Kirgisistan',
  'country.CY': 'Zypern',
  'country.KW': 'Kuwait',
  'country.KP': 'Nordkorea',
  'country.LA': 'Laos',
  'country.LB': 'Libanon',
  'country.MO': 'Macau',
  'country.MV': 'Malediven',
  'country.MY': 'Malaysia',
  'country.MM': 'Myanmar',
  'country.MN': 'Mongolei',
  'country.NP': 'Nepal',
  'country.UZ': 'Usbekistan',
  'country.PK': 'Pakistan',
  'country.SG': 'Singapur',
  'country.LK': 'Sri Lanka',
  'country.SY': 'Syrien',
  'country.SA': 'Saudi-Arabien',
  'country.TJ': 'Tadschikistan',
  'country.TH': 'Thailand',
  'country.TW': 'Taiwan',
  'country.TM': 'Turkmenistan',
  'country.OM': 'Oman',
  'country.JO': 'Jordanien',
  'country.VN': 'Vietnam',
  'country.YE': 'Jemen',
  'country.DZ': 'Algerien',
  'country.AO': 'Angola',
  'country.BJ': 'Benin',
  'country.BW': 'Botswana',
  'country.BF': 'Burkina Faso',
  'country.BI': 'Burundi',
  'country.CV': 'Kap Verde',
  'country.CM': 'Kamerun',
  'country.CF': 'Zentralafrikanische Republik',
  'country.TD': 'Tschad',
  'country.KM': 'Komoren',
  'country.CG': 'Republik Kongo',
  'country.CD': 'Demokratische Republik Kongo',
  'country.CI': 'Elfenbeinküste',
  'country.DJ': 'Dschibuti',
  'country.EG': 'Ägypten',
  'country.GQ': 'Äquatorialguinea',
  'country.ER': 'Eritrea',
  'country.SZ': 'Eswatini',
  'country.ET': 'Äthiopien',
  'country.GA': 'Gabun',
  'country.GM': 'Gambia',
  'country.GH': 'Ghana',
  'country.GN': 'Guinea',
  'country.GW': 'Guinea-Bissau',
  'country.KE': 'Kenia',
  'country.LS': 'Lesotho',
  'country.LR': 'Liberia',
  'country.LY': 'Libyen',
  'country.MG': 'Madagaskar',
  'country.MW': 'Malawi',
  'country.ML': 'Mali',
  'country.MR': 'Mauretanien',
  'country.MU': 'Mauritius',
  'country.YT': 'Mayotte',
  'country.MA': 'Marokko',
  'country.MZ': 'Mosambik',
  'country.NA': 'Namibia',
  'country.NE': 'Niger',
  'country.NG': 'Nigeria',
  'country.RE': 'Réunion',
  'country.RW': 'Ruanda',
  'country.SH': 'St. Helena',
  'country.ST': 'São Tomé und Príncipe',
  'country.SN': 'Senegal',
  'country.SC': 'Seychellen',
  'country.SL': 'Sierra Leone',
  'country.SO': 'Somalia',
  'country.ZA': 'Südafrika',
  'country.SS': 'Südsudan',
  'country.SD': 'Sudan',
  'country.TZ': 'Tansania',
  'country.TG': 'Togo',
  'country.TN': 'Tunesien',
  'country.UG': 'Uganda',
  'country.EH': 'Westsahara',
  'country.ZM': 'Sambia',
  'country.ZW': 'Simbabwe',
  'country.AU': 'Australien',
  'country.CX': 'Weihnachtsinsel',
  'country.CC': 'Kokosinseln',
  'country.CK': 'Cookinseln',
  'country.FJ': 'Fidschi',
  'country.PF': 'Französisch-Polynesien',
  'country.GU': 'Guam',
  'country.HM': 'Heard und McDonaldinseln',
  'country.KI': 'Kiribati',
  'country.MH': 'Marshallinseln',
  'country.FM': 'Mikronesien',
  'country.NR': 'Nauru',
  'country.NC': 'Neukaledonien',
  'country.NZ': 'Neuseeland',
  'country.NU': 'Niue',
  'country.NF': 'Norfolkinsel',
  'country.MP': 'Nördliche Marianen',
  'country.PW': 'Palau',
  'country.PG': 'Papua-Neuguinea',
  'country.PN': 'Pitcairninseln',
  'country.WS': 'Samoa',
  'country.SB': 'Salomonen',
  'country.TK': 'Tokelau',
  'country.TO': 'Tonga',
  'country.TV': 'Tuvalu',
  'country.VU': 'Vanuatu',
  'country.WF': 'Wallis und Futuna',
  'country.AQ': 'Antarktis',
  'country.BV': 'Bouvetinsel',
  'country.IO': 'Britisches Territorium im Indischen Ozean',
  'country.TF': 'Französische Süd- und Antarktisgebiete',
  'country.GS': 'Südgeorgien und die Südlichen Sandwichinseln',
  'Ticaret Sicil No': 'Handelsregister-Nr.',
}; 